import React from 'react'
import { OrderAccessRole } from 'components/Common/OrderView/OrderItemSummaries/shareOrder/types'
import StatusLabel from 'LuxKit/Label/StatusLabel'
import LineEyeIcon from 'LuxKit/Icons/line/LineEyeIcon'
import LineEditAltIcon from 'LuxKit/Icons/line/LineEditAltIcon'
import SubDetail from './SubDetail'

interface Props {
  order: App.Order
  hideSharedBy?: boolean
}

function SharedAccessTag({ order, hideSharedBy = false }: Props) {
  const { isSharedBooking, accessDetails, customerFullName } = order

  const { role } = accessDetails

  if (!isSharedBooking) {
    return null
  }

  return (
    <>
      {role === OrderAccessRole.VIEWER && (
        <SubDetail variant="medium">
          <StatusLabel
            variant="confirmation"
            startIcon={<LineEyeIcon />}
          >
            View Access
          </StatusLabel>
        </SubDetail>
      )}

      {role === OrderAccessRole.MANAGER && (
        <SubDetail variant="medium">
          <StatusLabel
            variant="confirmation"
            startIcon={<LineEditAltIcon />}
          >
            Manage Access
          </StatusLabel>
        </SubDetail>
      )}

      {!hideSharedBy && (
        <SubDetail variant="medium">
          shared by {customerFullName}
        </SubDetail>
      )}
    </>
  )
}

export default SharedAccessTag
